
import { View } from 'backbone';
import util from 'util/Util.js'
import Template from 'behaviors/properties/main/show-form.ejs';
import constants from 'Constants.js';
//=====================================================================
//
// An instance of this view represents a comment.
//
// Casey Justus, May 15, 2016
//
//=====================================================================

class MainShowFormView extends View {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;


        this.events = {
            'change input[name="parentChild"]'   : 'updateAttributes',
            'change input[type="checkbox"]':'updateCheckboxes'
        };



        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    updateCheckboxes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        this.model.set( propName, propVal );
    }



    render() {
        
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $("input:radio[value='"+this.model.get('parentChild')+"']").attr('checked', true);

        let bShowError = util.isTrue(this.model.get('showError'));
        $(`input[name='showError']`).prop('checked', bShowError );

        let bNewWindow = util.isTrue(this.model.get('newWindow'));
        $(`input[name='newWindow']`).prop('checked', bNewWindow );

        const parentChild = this.model.get('parentChild')

        if(parentChild === 'existing' || parentChild === 'existing2' || parentChild === 'parent') {
            $('#selectForm').prop('disabled',true);
        }
        else{
            $('#selectForm').prop('disabled',false);
        }

        this.delegateEvents();
        util.setGridScrollPos(this.model);
        return this;
    }

}

export default MainShowFormView;
